import { rudderTrack } from "./init";
import SimpleTrack from "../../../../../common/types/release/simple-track";
import { SimpleRelease } from "../../../../../common/types/release/simple-release";
import { Release } from '../../../../../common/types/release/release';

export const handleReleaseTransferred = async (
  { release, tracks, userId }:
    {release: SimpleRelease | Release, tracks?: SimpleTrack[], userId: string}
) => {
  
  const songs = tracks?.map((track) => {
    return {
      name: track.title,
      track_version: track.trackVersion,
      instrumental: track.type,
      explicit: track.isExplicit,
      lyrics: track.lyrics,
      language: track.language,
      isrc: track.isrc,
      instant_gratification: track.isInstantGratification,
      copyright_status: track.ownProduced,
    };
  }) ?? [];
  
  const artists = release.artists.map((artist) => {
    return {
      name: artist.name,
      id: artist.id,
      email: artist.email,
    };
  });
  
  if (window.analytics) {
    window.analytics.track("Backoffice Release Transferred", {
      releaseName: release.title,
      artists,
      paidItems: release.paidItems,
      stores: "stores" in release ? release.stores : [],
      regions: "regions" in release ? release.regions : [],
      releaseId: release.id,
      dateAdded: release.submitDate,
    });
  }
  await rudderTrack("Backoffice Release Transferred", {
    release_id: release.id,
    release_name: release.title,
    artist_id: release.ownerId ?? '',
    artist_name: release.artists.length > 1
      ? release.artists.map(artist => artist.name)
      : release.artists[0].name,
    songs,
    release_date: release?.releaseDate ?? '',
    transferred_to: userId
  });
};

export const handleReleaseDeleted = async (
  { release, tracks}: {release: SimpleRelease | Release, tracks?: SimpleTrack[]}
) => {
  const songs = tracks?.map((track) => {
    return {
      name: track.title,
      track_version: track.trackVersion,
      instrumental: track.type,
      explicit: track.isExplicit,
      lyrics: track.lyrics,
      language: track.language,
      isrc: track.isrc,
      instant_gratification: track.isInstantGratification,
      copyright_status: track.ownProduced,
    };
  }) ?? [];
  
  const artists = release.artists.map((artist) => {
    return {
      name: artist.name,
      id: artist.id,
      email: artist.email,
    };
  });
  
  if (window.analytics) {
    window.analytics.track("Backoffice Release Deleted", {
      releaseName: release.title,
      artists,
      paidItems: release.paidItems,
      stores: "stores" in release ? release.stores : [],
      regions: "regions" in release ? release.regions : [],
      releaseId: release.id,
      dateAdded: release.submitDate,
    });
  }
  
  await rudderTrack("Backoffice Release Deleted", {
    release_id: release.id,
    release_name: release.title,
    artist_id: release.ownerId ?? '',
    artist_name: release.artists.length > 1
      ? release.artists.map(artist => artist.name)
      : release.artists[0].name,
    songs,
    release_date: release?.releaseDate ?? '',
  });
};

export const handleReleaseTakenDown = async (
  { release, tracks}: {release: SimpleRelease | Release, tracks?: SimpleTrack[]}
) => {
  const songs = tracks?.map((track) => {
    return {
      name: track.title,
      track_version: track.trackVersion,
      instrumental: track.type,
      explicit: track.isExplicit,
      lyrics: track.lyrics,
      language: track.language,
      isrc: track.isrc,
      instant_gratification: track.isInstantGratification,
      copyright_status: track.ownProduced,
    };
  }) ?? [];
  
  const artists = release.artists.map((artist) => {
    return {
      name: artist.name,
      id: artist.id,
      email: artist.email,
    };
  });
  
  if (window.analytics) {
    window.analytics.track("Backoffice Release Taken Down", {
      releaseName: release.title,
      artists,
      paidItems: release.paidItems,
      stores: "stores" in release ? release.stores : [],
      regions: "regions" in release ? release.regions : [],
      releaseId: release.id,
      dateAdded: release.submitDate,
    });
  }
  
  await rudderTrack("Backoffice Release Taken Down", {
    release_id: release.id,
    release_name: release.title,
    artist_id: release.ownerId ?? '',
    artist_name: release.artists.length > 1
      ? release.artists.map(artist => artist.name)
      : release.artists[0].name,
    songs,
    release_date: release?.releaseDate ?? '',
  });
};

export const handleReleaseRejected = async (
  { release, tracks}: {release: SimpleRelease | Release, tracks?: SimpleTrack[]}
) => {
  const songs = tracks?.map((track) => {
    return {
      name: track.title,
      track_version: track.trackVersion,
      instrumental: track.type,
      explicit: track.isExplicit,
      lyrics: track.lyrics,
      language: track.language,
      isrc: track.isrc,
      instant_gratification: track.isInstantGratification,
      copyright_status: track.ownProduced,
    };
  }) ?? [];
  
  const artists = release.artists.map((artist) => {
    return {
      name: artist.name,
      id: artist.id,
      email: artist.email,
    };
  });
  
  if (window.analytics) {
    window.analytics.track("Backoffice Release Rejected", {
      releaseName: release.title,
      artists,
      paidItems: release.paidItems,
      stores: "stores" in release ? release.stores : [],
      regions: "regions" in release ? release.regions : [],
      releaseId: release.id,
      dateAdded: release.submitDate,
    });
  }
  
  await rudderTrack("Backoffice Release Rejected", {
    release_id: release.id,
    release_name: release.title,
    artist_id: release.ownerId ?? '',
    artist_name: release.artists.length > 1
      ? release.artists.map(artist => artist.name)
      : release.artists[0].name,
    songs,
    release_date: release?.releaseDate ?? '',
  });
};

export const handleReleaseEditRequested = async (
  { release, tracks}: {release: SimpleRelease | Release, tracks?: SimpleTrack[]}
) => {
  const songs = tracks?.map((track) => {
    return {
      name: track.title,
      track_version: track.trackVersion,
      instrumental: track.type,
      explicit: track.isExplicit,
      lyrics: track.lyrics,
      language: track.language,
      isrc: track.isrc,
      instant_gratification: track.isInstantGratification,
      copyright_status: track.ownProduced,
    };
  }) ?? [];
  
  const artists = release.artists.map((artist) => {
    return {
      name: artist.name,
      id: artist.id,
      email: artist.email,
    };
  });
  
  if (window.analytics) {
    window.analytics.track("Backoffice Release Edit Requested", {
      releaseName: release.title,
      artists,
      paidItems: release.paidItems,
      stores: "stores" in release ? release.stores : [],
      regions: "regions" in release ? release.regions : [],
      releaseId: release.id,
      dateAdded: release.submitDate,
    });
  }
  
  await rudderTrack("Backoffice Release Edit Requested", {
    release_id: release.id,
    release_name: release.title,
    artist_id: release.ownerId ?? '',
    artist_name: release.artists.length > 1
      ? release.artists.map(artist => artist.name)
      : release.artists[0].name,
    songs,
    release_date: release?.releaseDate ?? '',
  });
};

export const handleReleaseApproved = async (
  { release, tracks}: {release: SimpleRelease | Release, tracks?: SimpleTrack[]}
) => {
  const songs = tracks?.map((track) => {
    return {
      name: track.title,
      track_version: track.trackVersion,
      instrumental: track.type,
      explicit: track.isExplicit,
      lyrics: track.lyrics,
      language: track.language,
      isrc: track.isrc,
      instant_gratification: track.isInstantGratification,
      copyright_status: track.ownProduced,
    };
  }) ?? [];
  
  const artists = release.artists.map((artist) => {
    return {
      name: artist.name,
      id: artist.id,
      email: artist.email,
    };
  });
  
  if (window.analytics) {
    window.analytics.track("Backoffice Release Approved", {
      releaseName: release.title,
      artists,
      paidItems: release.paidItems,
      stores: "stores" in release ? release.stores : [],
      regions: "regions" in release ? release.regions : [],
      releaseId: release.id,
      dateAdded: release.submitDate,
    });
  }
  
  await rudderTrack("Backoffice Release Approved", {
    release_id: release.id,
    release_name: release.title,
    artist_id: release.ownerId ?? '',
    artist_name: release.artists.length > 1
      ? release.artists.map(artist => artist.name)
      : release.artists[0].name,
    songs,
    release_date: release?.releaseDate ?? '',
  });
};
